'use client';

import React from 'react';
import { VideoItem } from '@/app/_api/fetchGalleryContent';
import VideoPlayer from './VideoPlayer';

import classes from './VideoGrid.module.scss';
import { renderTrademarkText } from '../TrademarkText';

interface VideoGridProps {
  videos: VideoItem[];
  cols?: number;
  mobileCols?: number;
}

export const VideoGrid: React.FC<VideoGridProps> = ({ videos, cols = 3, mobileCols = 1 }) => {
  if (videos.length === 0) {
    return <p className={classes.empty}>No videos found with current filters.</p>;
  }
  const [vimeoLoaded, setVimeoLoaded] = React.useState(false);
  const [testCount, setTestCount] = React.useState(0);

  React.useEffect(() => {
    const vimeoTest =
      typeof window !== 'undefined' &&
      (window as typeof window & { VimeoCheckedUrlTimeParam?: unknown })
        .VimeoCheckedUrlTimeParam !== undefined;
    console.log({ vimeoTest });

    if (vimeoTest) {
      setVimeoLoaded(true);
    } else {
      window.setTimeout(() => setTestCount(testCount + 1), 1500);
    }
  }, [testCount]);

  return (
    <div
      className={classes.grid}
      style={
        {
          '--desktop-cols': cols,
          '--mobile-cols': mobileCols,
        } as React.CSSProperties
      }
    >
      {videos.map(video =>
        video?.hideVideo ? null : (
          <div key={`${video.id}_${vimeoLoaded ? 'loaded' : ''}`} className={classes.item}>
            <VideoPlayer videoUrl={video.videoUrl} title={video.title} />
            <h4 className={classes.title}>{video.title ? renderTrademarkText(video.title) : null}</h4>
          </div>
        ),
      )}
    </div>
  );
};

export default VideoGrid;
